// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__27gD2","label":"LabeledBox_label__3zKu3"};